import React, { useEffect, useRef, useState } from 'react';
import { read, save, GA4_ENABLED } from 'common/consent';
import { Banner } from './cookieBanner.style';

// Shown on the first visit and again from "Cookie settings". Wide at the bottom
// centre, so it covers part of the page until the visitor decides. Still not
// modal: no dimmed page, no scroll lock, the page works without a choice.
// It sits first in the DOM, so Tab reaches it first.
const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  const [choice, setChoice] = useState(null);
  const firstButton = useRef(null);
  const fromSettings = useRef(false);

  useEffect(() => {
    const current = read();
    setChoice(current);
    setOpen(!current);
    const onOpen = () => {
      fromSettings.current = true;
      setChoice(read());
      setOpen(true);
    };
    window.addEventListener('cp-open-consent', onOpen);
    return () => window.removeEventListener('cp-open-consent', onOpen);
  }, []);

  useEffect(() => {
    if (open && fromSettings.current && firstButton.current) {
      firstButton.current.focus();
    }
  }, [open]);

  if (!open) return null;

  const decide = (analytics) => {
    save(analytics);
    setChoice(read());
    setOpen(false);
    fromSettings.current = false;
  };

  return (
    <Banner
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-banner-title"
      aria-live="polite"
    >
      <p>
        <strong id="cookie-banner-title">Cookies</strong>
        {GA4_ENABLED ? (
          <>
            May we use Hotjar and Google Analytics cookies? Hotjar records how
            visitors scroll and click on this site. Google Analytics counts
            visits and shows which link or campaign they came from. Both are
            optional and stay off until you agree.
          </>
        ) : (
          <>
            May we use Hotjar cookies to record how visitors scroll and click
            on this site? It is optional and stays off until you agree.
          </>
        )}{' '}
        Change your choice anytime in Cookie settings.{' '}
        <a href="/privacy/">Privacy policy</a>
        {choice && (
          <span className="current">
            Current choice: {choice.analytics ? 'accepted' : 'rejected'}
          </span>
        )}
      </p>
      <div className="buttons">
        <button type="button" ref={firstButton} onClick={() => decide(false)}>
          Reject
        </button>
        <button type="button" onClick={() => decide(true)}>
          Accept
        </button>
      </div>
    </Banner>
  );
};

export default CookieBanner;
